module.exports = __webpack_public_path__ + "img/tr.9fd06c2c.svg";